import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Material, Project } from 'src/app/shared/models';
import { AppService, MaterialService } from 'src/app/shared/services';
import { MaterialCreateComponent } from '../material-create/material-create.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components';

@Component({
    selector: 'app-materials',
    templateUrl: './materials.component.html',
    styleUrls: ['./materials.component.scss'],
    standalone: false
})
export class MaterialsComponent implements OnInit {
  public loading = 0;
  public initialized = false;

  @Input()
  public project: Project;

  @Input()
  public pageSize = 20;

  public materials: Material[] = [];
  public newMaterial: Material; // for acl purpose
  public pagination = {
    pageIndex: 0,
    length: 0,
    pageSize: this.pageSize,
  };

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private appSrv: AppService,
    private materialSrv: MaterialService
  ) { }

  ngOnInit(): void {
    this.pagination.pageSize = this.pageSize;
    this.newMaterial = new Material({ project: this.project });
    this.fetchRecords();
  }

  /**
   * Fetches Material[] from API
   */
  fetchRecords(): void {
    this.loading++;

    this.materialSrv
      .getRecords(this.project, this.pagination, { include: ['bid_items'] })
      .then((resp: any) => {
        const { result, meta } = resp;

        // for acl
        this.materials = result.map((o) => {
          o.project = this.project;
          return new Material(o);
        });

        this.pagination.length = meta?.totalRecords ?? 0;
      })
      .catch((resp: HttpErrorResponse) => {
        this.snackBar.open(resp.error.error, '', { duration: 5000 });
      })
      .finally(() => {
        this.initialized = true;
        this.loading--;
      });
  }

  /**
   * Open sidebar for edit/create
   * @param material Material
   */
  openMaterialEdit(material: Material) {
    const sidebarRef = this.appSrv.openSidebar(MaterialCreateComponent, {
      data: material,
      project: this.project,
      editable: true,
    });

    sidebarRef.afterClosed().subscribe((resp) => {
      if (resp instanceof Material) {
        const i = this.materials.findIndex((o) => o.id === resp.id);
        if (i >= 0) {
          this.materials[i] = Object.assign(this.materials[i], resp);
          this.snackBar.open(`"${resp.name}" updated successfully`, '', {
            duration: 5000,
          });
        } else {
          this.materials.push(resp);
          this.pagination.length++;
          this.snackBar.open(`"${resp.name}" added successfully`, '', {
            duration: 5000,
          });
        }
      }
    });
  }

  /**
   * Deletes Material
   * @param material Material
   */
  delete(material: Material) {
    const message = `Deleting ${material.name} cannot be undone.
      <br />Proceed to delete?`;
    const dialogData = new ConfirmDialogModel('Delete?', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.materialSrv.delete(material)
        .then((resp: any) => {
          const i = this.materials.findIndex((o) => material.id);
          this.materials.splice(i, 1);
          this.snackBar.open(`${resp.message}`, '', {
            duration: 3000,
          });
        })
        .catch((resp: HttpErrorResponse) => {
          if (resp.status === 403) {
            this.snackBar.open(
              resp.error.error || 'Oops! something went wrong.',
              '',
              { duration: 5000 }
            );
            return;
          }

          this.snackBar.open(
            'Oops! something went wrong, please check the logs',
            '',
            { duration: 5000 }
          );
        });
    });
  }

}
